import { useEffect, useState } from "react";
import { Html5Qrcode } from "html5-qrcode";
import { QrCode } from "lucide-react";
import { toast } from "sonner";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Dialog, DialogContent, DialogHeader, DialogTitle } from "@/components/ui/dialog";
import { api, errMsg } from "@/lib/api";

function Reader({ onCode }) {
  useEffect(() => {
    let s = null;
    let done = false;
    const t = setTimeout(() => {
      s = new Html5Qrcode("qr-reader");
      s.start({ facingMode: "environment" }, { fps: 10, qrbox: 220 }, (txt) => {
        if (done) return;
        done = true;
        onCode(txt.trim());
      }, () => {}).catch(() => toast.error("Camera not available. Type the drum code below."));
    }, 150);
    return () => { clearTimeout(t); if (s?.isScanning) s.stop().catch(() => {}); };
  }, [onCode]);
  return <div id="qr-reader" className="w-full min-h-[240px] rounded-md overflow-hidden bg-black/90" data-testid="qr-reader" />;
}

export function ScanButton({ onDrum, label = "Scan drum", testid = "scan-drum-btn", className }) {
  const [open, setOpen] = useState(false);
  const [code, setCode] = useState("");
  const find = async (c) => {
    if (!c) return;
    try { const { data } = await api.get(`/scan/${encodeURIComponent(c)}`); setOpen(false); setCode(""); onDrum(data); } catch (e) { toast.error(errMsg(e)); }
  };
  return (
    <>
      <Button type="button" variant="outline" onClick={() => setOpen(true)} className={className} data-testid={testid}><QrCode className="h-4 w-4 mr-1" />{label}</Button>
      <Dialog open={open} onOpenChange={setOpen}>
        <DialogContent className="w-[calc(100vw-1.5rem)] max-w-md" data-testid="scan-dialog">
          <DialogHeader><DialogTitle>Scan drum QR sticker</DialogTitle></DialogHeader>
          {open && <Reader onCode={find} />}
          <form className="flex gap-2" onSubmit={(e) => { e.preventDefault(); find(code.trim()); }}>
            <Input value={code} onChange={(e) => setCode(e.target.value.toUpperCase())} placeholder="Or type drum code (RX-D… or Mfr no)" data-testid="scan-code-input" />
            <Button type="submit" data-testid="scan-find-btn">Find</Button>
          </form>
        </DialogContent>
      </Dialog>
    </>
  );
}
